<template>
    <div class="order-address order-step" :class="{ '_map-debug-mode': isMapDebugMode }">
        <div class="order-step__title order-address__title">Ваш адрес
            <div class="_g-visible-mobile order-address__onmap" @click="showPopup">На карте</div>
        </div>
        <order-address-debug-filters
            v-if="isMapDebugMode"
            :service-areas="serviceAreas"
            :ymap="map"
        />
        <div class="order-address__popup" data-scroll-lock-scrollable :class="{opened: popup}">
            <div class="order-address__popup-top">
                <div class="order-address__popup-top-back" @click="closePopup">Назад</div>
                <div class="order-address__popup-top-close" @click="closePopup"></div>
            </div>
            <lazy-component @show="handler">
                <div class="order-address__map">
                    <div style="height: 100%;" id="map"></div>
                </div>
            </lazy-component>

            <div v-if="isMapDebugMode && medsiServiceArea" style="margin-top: -30px; margin-bottom: 30px;">
                ID зоны: <b>{{ medsiServiceArea.id }}</b><br>
                Регион: <b>{{ medsiServiceArea.regionCode }}</b><br>
                Подходящая область: <b>{{ medsiServiceArea.geoObjectName }}</b>
                <template v-if="medsiServiceArea.distance">
                    <br>
                    Расстояние: <b>{{ medsiServiceArea.distance.toFixed() }} км</b>
                </template>
            </div>

            <form class="form order-address__form" @submit.prevent="nextStep()">
                <div class="form__row">
                    <div class="form__field" :class="{focused: request, error: error || selfInput}">
                        <div class="form__field-wrapper">
                            <div class="form__field-label">Адрес</div>
                            <input type="text" name="address" v-focus v-model="request" @change="selfInput = true">
                            <input-helpers
                                :input-value="request"
                                :coords="coordsAddress"
                                input-name="address"
                                @inputHelpersChange="inputHelpersChange"
                                v-model.trim="request"
                                ref="inputHelper"
                            />
                        </div>
                        <label v-if="error" class="error">{{ error }}</label>
                        <label v-if="selfInput && !error" class="error">Пожалуйста, выберите адрес из предложенных или сделайте отметку на карте</label>
                    </div>
                    <button type="button" class="order-address__usrlocation _g-hidden-mobile"
                            @click.prevent="setCurrentLocation"></button>
                </div>
                <div class="form__row order-address__additional">
                    <div class="form__field" :class="{focused: flat, error: !$v.flat.isCorrect || $v.flat.$error}">
                        <div class="form__field-wrapper">
                            <div class="form__field-label">Квартира</div>
                            <input type="text" v-focus v-model="flat" @blur="$v.flat.$touch()">
                        </div>
                        <div class="errors" v-if="$v.flat.$error">
                            <div class="error" v-if="!$v.flat.required">Обязательное поле</div>
                            <div class="error" v-if="!$v.flat.isCorrect">Недопустимый формат</div>
                            <div class="error" v-if="!$v.flat.maxLength">Не более 5 символов</div>
                        </div>
                    </div>
                    <div class="form__field"
                         :class="{focused: entrance, error: !$v.entrance.isCorrect || $v.entrance.$error}">
                        <div class="form__field-wrapper">
                            <div class="form__field-label">Подъезд</div>
                            <input type="text" v-focus v-model="entrance" @blur="$v.entrance.$touch()">
                        </div>
                        <div class="errors" v-if="$v.entrance.$error">
                            <div class="error" v-if="!$v.entrance.isCorrect">Недопустимый формат</div>
                            <div class="error" v-if="!$v.entrance.maxLength">Не более 3 символов</div>
                        </div>
                    </div>
                    <div class="form__field" :class="{focused: floor, error: !$v.floor.isCorrect || $v.floor.$error}">
                        <div class="form__field-wrapper">
                            <div class="form__field-label">Этаж</div>
                            <input type="text" v-focus v-model="floor" @blur="$v.floor.$touch()">
                        </div>
                        <div class="errors" v-if="$v.floor.$error">
                            <div class="error" v-if="!$v.floor.isCorrect">Недопустимый формат</div>
                            <div class="error" v-if="!$v.floor.maxLength">Не более 3 символов</div>
                        </div>
                    </div>
                    <div class="form__field"
                         :class="{focused: intercom, error: !$v.intercom.isCorrect || $v.intercom.$error}">
                        <div class="form__field-wrapper">
                            <div class="form__field-label">Домофон</div>
                            <input type="text" v-focus v-model="intercom" @blur="$v.intercom.$touch()">
                        </div>
                        <div class="errors" v-if="$v.intercom.$error">
                            <div class="error" v-if="!$v.intercom.isCorrect">Недопустимый формат</div>
                            <div class="error" v-if="!$v.intercom.maxLength">Не более 10 символов</div>
                        </div>
                    </div>
                </div>
                <div class="order-services__buttons">
                    <button type="button" class="button button_light" @click.prevent="prevStep">Назад</button>
                    <input class="form__submit button button_dark" type="submit" value="Перейти к услугам"
                        :disabled="disabledNextBtn">
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { loadYmap } from 'vue-yandex-maps';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { required, maxLength } from 'vuelidate/lib/validators';
import {
    serviceAreas as initialServiceAreas,
    addYmapPolygonsToServiceAreas,
    getMedsiServiceAreaByCoords
} from '../modules/medsiServiceAreas';
import getUrlParams from '../assets/js/getUrlParams';
import OrderAddressDebugFilters from './OrderAddressDebugFilters';
import InputHelpers from "@/components/input-helpers";
import axios from "axios";
import formData from '../assets/js/_formData';

const { debug: isMapDebugMode } = getUrlParams();

export default {
    name: 'orderAddress',
    components: {
        OrderAddressDebugFilters,
        InputHelpers
    },
    props: {
        addressMain: {
            type: String,
            default: '',
        },
        address: {
            type: Object,
            default: () => ({}),
        },
        currentRegionCode: {
            type: String,
            default: 'moscow',
        },
        serviceAreaLimitation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        let currentRegionName = window.GLOBAL_REGION_NAME;

        if (currentRegionName) {
            currentRegionName = currentRegionName.replace('и МО', '').trim();
        }

        const defaultRequest = (currentRegionName) ? `${currentRegionName}, ` : '';

        return {
            inited: false,
            map: null,
            userLocation: null,
            placemark: null,
            request: defaultRequest,
            defaultRequest,
            error: '',
            flat: '',
            entrance: '',
            floor: '',
            intercom: '',
            popup: false,
            coords: [],
            medsiServiceArea: this.address.medsiServiceArea ? this.address.medsiServiceArea : null,
            isMobile: window.matchMedia('(min-width: 0px) and (max-width: 767px)').matches,
            addressInputFocused: false,
            coordsAddress: [],
            dadataInfo: this.address.dadataInfo,
            selfInput: false
        }
    },
    computed: {
        serviceAreas() {
            return initialServiceAreas;
        },
        addressObject() {
            return {
                request: this.request,
                entrance: this.entrance,
                flat: this.flat,
                floor: this.floor,
                intercom: this.intercom,
                coords: this.coords,
                medsiServiceArea: this.medsiServiceArea,
                dadataInfo: this.dadataInfo
            }
        },
        disabledNextBtn() {
            return this.error
                || !this.request.trim()
                || this.request.trim() === this.defaultRequest.trim()
                || this.$v.$invalid
                || this.selfInput
                || this.addressInputFocused;
        },
        isMapDebugMode() {
            return isMapDebugMode;
        },
    },
    validations() {
        return {
            flat: {
                required,
                isCorrect: (param) => {
                    return param ? /^[0-9]([А-Яа-яЁё0-9 ]+)?$/.test(param) : true;
                },
                maxLength: maxLength(5),
            },
            entrance: {
                isCorrect: (param) => {
                    return param ? /^[0-9]+$/.test(param) : true;
                },
                maxLength: maxLength(3),
            },
            floor: {
                isCorrect: (param) => {
                    return param ? /^[0-9]+$/.test(param) : true;
                },
                maxLength: maxLength(3),
            },
            intercom: {
                isCorrect: (param) => {
                    return param ? /^[А-Яа-яЁёA-Za-z0-9#*]+$/.test(param) : true;
                },
                maxLength: maxLength(10),
            },
        }
    },
    methods: {
        async handler() {
            if (this.inited && this.map) {
                return;
            }

            if (Object.keys(this.address).length) {
                this.request = this.address.request;
                this.entrance = this.address.entrance;
                this.flat = this.address.flat;
                this.floor = this.address.floor;
                this.intercom = this.address.intercom;
            }

            loadYmap({ apiKey: window.yandexApiKey, debug: true }).then(() => {
                this.inited = true;
                window.ymaps.ready(() => {
                    if (!this.map) {
                        this.map = new window.ymaps.Map('map', {
                            center: [55.753994, 37.622093],
                            zoom: 12,
                            controls: [],
                        });

                        addYmapPolygonsToServiceAreas(this.serviceAreas, this.map, { debugMode: isMapDebugMode });

                        this.address.request ? this.geocode(this.address.request, false) : ''

                        window.ymaps.geolocation.get().then(
                            (result) => {
                                this.userLocation = result.geoObjects;
                                if (!this.request || this.request === this.defaultRequest) {
                                    this.findUserLocation();
                                }
                            },
                            (err) => {
                                console.log('Ошибка: ' + err)
                            },
                        );

                        // const suggestView = new window.ymaps.SuggestView('suggest');

                        // if (this.request && (this.request !== this.defaultRequest)) {
                        //     this.geocode(this.request);
                        // }
                        //
                        // suggestView.events.add('select', (e) => {
                        //     this.request = e.get('item').value;
                        //     this.geocode(e.get('item').value);
                        // })

                        this.address.request ? this.geocode(this.address.request, false) : '';

                        this.map.events.add('click', (e) => {
                            const coords = e.get('coords');

                            if (this.placemark) {
                                this.placemark.geometry.setCoordinates(coords);
                            } else {
                                this.setPlacemark(coords);
                            }

                            this.geocode(coords);
                        });
                    }
                });
            })
        },
        setPlacemark(coords) {
            this.placemark = new window.ymaps.Placemark(
                coords, {}, {
                    iconLayout: 'default#image',
                    iconImageHref: this.isMobile ? '/local/templates/pnd/src/assets/i2/pin-mobile.svg' : '/local/templates/pnd/src/assets/i2/pin.png',
                    iconImageSize: this.isMobile ? [36, 36] : [68, 69],
                    iconImageOffset: this.isMobile ? [-18, -36] : [-34, -69],
                    draggable: true,
                });
            this.map.geoObjects.add(this.placemark);
            this.placemark.events.add('dragend', () => {
                this.geocode(this.placemark.geometry.getCoordinates());
            })
        },
        findOnMap(state) {
            if (!this.map) {
                this.map = new window.ymaps.Map('map', state);
                this.setPlacemark(this.map.getCenter())
            } else {
                if (!this.placemark) {
                    this.setPlacemark(state.center);
                }
                this.map.setCenter(state.center, state.zoom);
                this.placemark.geometry.setCoordinates(state.center);
            }
        },
        geocode(request, canSwitchRequest = true) {
            window.ymaps.geocode(request).then((res) => {
                const obj = res.geoObjects.get(0);

                if (obj) {
                    switch (obj.properties.get('metaDataProperty.GeocoderMetaData.precision')) {
                        case 'number':
                        case 'exact':
                            this.error = '';
                            this.$v.flat.$touch();
                            break;
                        case 'near':
                        case 'range':
                        case 'street':
                        case 'other':
                        default:
                            this.$v.flat.$reset();
                            this.error = 'Пожалуйста, уточните адрес';
                    }
                    this.coords = obj.geometry.getCoordinates();

                    if (this.serviceAreaLimitation) {
                        this.medsiServiceArea = getMedsiServiceAreaByCoords(this.coords);

                        if (!this.medsiServiceArea) {
                            this.error = 'Адрес не входит в зону обслуживания МЕДСИ';
                        } else if (this.medsiServiceArea.regionCode !== this.currentRegionCode) {
                            this.error = 'Адрес находится вне обслуживания текущего региона';
                        }
                    }

                    if (this.request.trim() !== [obj.getAddressLine()].join(', ').trim() && canSwitchRequest) {
                        this.getAddressByCoords(obj.geometry.getCoordinates());
                    }
                } else {
                    this.error = 'Пожалуйста, уточните позицию на карте';
                }
                if (!this.error) {
                    this.showResult(obj);
                }
            }, (e) => {
                console.log(e)
            })
        },
        showResult(obj) {
            const mapContainer = document.getElementById('map'),
                bounds = obj.properties.get('boundedBy'),
                mapState = window.ymaps.util.bounds.getCenterAndZoom(
                    bounds,
                    [mapContainer.offsetWidth, mapContainer.offsetHeight],
                ),
                shortAddress = [obj.getThoroughfare(), obj.getPremiseNumber(), obj.getPremise()].join(' ');
            mapState.controls = [];
            this.findOnMap(mapState, shortAddress);
        },
        findUserLocation() {
            if (!this.placemark) {
                this.setPlacemark(this.userLocation.position)
                this.map.setCenter(this.userLocation.position)
            } else {
                this.map.setCenter(this.userLocation.position);
                this.placemark.geometry.setCoordinates(this.userLocation.position);
            }
        },
        setCurrentLocation() {
            this.findUserLocation();
            this.geocode(this.userLocation.position);
        },
        prevStep() {
            this.$emit('prev');
        },
        nextStep() {
            enablePageScroll();
            this.$v.$touch();
            this.$emit('next');
            this.$emit('getPrices');
            //this.$emit('update:addressMain', this.address);
            this.$emit('update:address', this.addressObject);
        },
        showPopup() {
            this.popup = true;
            disablePageScroll();
            this.$nextTick(() => {
                this.map.container.fitToViewport();
                this.geocode(this.request);
            });
        },
        closePopup() {
            enablePageScroll();
            this.popup = false;
        },
        inputHelpersChange(field) {
            this.request = field.value.value;
            this.dadataInfo = field.value.data;
            this.geocode(field.value.value, false);
            this.selfInput = false;
        },
        getAddressByCoords(coords){
            const data = formData({
                lat: coords[0],
                lon: coords[1]
            });

            axios({
                url: '/api/2.0/dadata/geolocate/',
                method: 'post',
                data,
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(response => {
                this.request = response.data.data.length ? response.data.data[0].value : '';
                this.dadataInfo = response.data.data.length ? response.data.data[0].data : '';
                this.selfInput = false;
            })
        },
        setAddressFromGeolocation(field) {
            const self = this;
            navigator.geolocation.getCurrentPosition(function(position) {
                const lat = position.coords.latitude;
                const lon = position.coords.longitude;

                const coords = {
                    lat,
                    lon
                };

                self.getAddressWithPosition(coords, field);
            });
        },
    },
}
</script>

<style lang="scss">
@import "../../scss/base/include";

.order-address {
    margin-bottom: 67px !important;

    &__title {
        margin-bottom: 35px;

        @include tablet {
            margin-bottom: 26px;
        }
        @include mobile {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            margin-bottom: 14px;
        }
    }

    &__onmap {
        font-size: 12px;
        line-height: 14px;
        color: rgba(125, 121, 135, 0.5);
    }

    &__popup {
        &-top {
            display: none;

            &-back {
                color: $accent;
                font-size: 14px;
                line-height: 17px;

                &::before {
                    content: '';
                    width: 15px;
                    height: 9px;
                    background: center url(/local/templates/pnd/src/assets/i2/dropdown.svg) no-repeat;
                    display: inline-block;
                    transform: rotate(90deg);
                    margin: 0 4px 0 -4px;
                }
            }

            &-close {
                background: center url(/local/templates/pnd/src/assets/i2/close2.svg) no-repeat;
                width: 28px;
                height: 28px;
            }
        }

        &.opened {
            position: fixed;
            top: 0;
            left: 0;
            background-color: $white-true;
            z-index: 100;
            height: 100%;
            overflow: auto;
            padding: 0 12px 22px;

            .order-address__popup-top {
                display: flex;
                height: 47px;
                align-items: center;
                justify-content: space-between;
            }
        }
    }

    &__map {
        height: 260px;
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        margin-bottom: 60px;

        ._map-debug-mode & {
            height: 600px;

            &::after {
                display: none;
            }
        }

        @include tablet {
            margin: 0 -32px 30px;
            border-radius: 0px;
        }
        @include mobile {
            height: 0;
            margin-bottom: 0;
            margin: 0 -12px 0;
            .order-address__popup.opened & {
                height: 244px;
                margin-bottom: 11px;
            }
        }

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            background: rgba(0, 171, 170, 0.2);
            top: 0;
            left: 0;
            pointer-events: none;
            height: 100%;
        }
    }

    &__form {
        max-width: 760px;
        @include mobile {
            max-width: 540px;
        }

        & .form__field .errors {
            position: absolute;
            top: calc(100% + 2px);

            @include mobile {
                position: static;
            }

            .error {
                position: static !important;
                font-size: 13px;

                @include mobile {
                    font-size: 11px;
                    margin-top: 1px;
                }
            }
        }

        & .form__field-wrapper .errors {
            position: static !important;
        }
    }

    &__usrlocation {
        width: 60px;
        height: 60px;
        min-width: 60px;
        border: 1px solid rgba(125, 121, 135, 0.2);
        border-radius: 5px;
        margin: 0 10px;
        background: $white-true center url(/local/templates/pnd/src/assets/i2/place.svg) no-repeat;
        cursor: pointer;
        outline: none;
    }

    .form__row {
        margin-bottom: 42px;
        @include mobile {
            flex-wrap: wrap;
            margin: 0 -8px 0;
            .form__field {
                margin: 0 8px 17px;
            }
        }

        &.order-address__additional {
            @include mobile {
                .form__field {
                    flex: auto;
                    width: calc(50% - 20px);
                }
            }
        }
    }

    .form__submit {
        @include tablet {
            height: 50px;
        }
    }
}

.input-helpers {
    width: 100%;
    bottom: 0;
    transform: translateY(100%);
    color: #000;
}

.form__field-wrapper input:focus + .input-helpers, {
    display: flex;
}

.order-services__buttons .button.button_light {
    margin-right: 10px;
}

ymaps[class*="i-custom-scroll"] {
    right: 0px;
    left: 0px;
    box-shadow: none;
    border: 1px solid rgba(125, 121, 135, 0.2);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

ymaps[class*="search__suggest-item_selected_yes"] {
    background-color: rgba(0, 171, 170, 0.2);
}
</style>
